import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "22",
      height: "23",
      x: "0",
      y: "2",
      "mask-type": "luminance",
      maskUnits: "userSpaceOnUse"
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M4 8v11h16V8zm18 11c0 1.102-.898 2-2 2H4c-1.102 0-2-.898-2-2V8c0-1.102.898-2 2-2h16c1.102 0 2 .898 2 2z"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        d: "M14 7V4h-4v3a1 1 0 0 1-2 0V4c0-1.102.898-2 2-2h4c1.102 0 2 .898 2 2v3a1 1 0 1 1-2 0"
      }),
      _createElementVNode("path", {
        fill: "#000",
        d: "M6 13c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        d: "M9 18a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        d: "M5 22v-6a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M24 0H0v24h24z"
      })
    ], -1)
  ]))]))
}
export default { render: render }